import img1 from '../assets/testimonials/Nelly Brown.png';
import img2 from '../assets/testimonials/Chris Mark.jpg';
import img3 from '../assets/testimonials/Peter Brown.jpg';




export const testimonials = [
    {
        banner: img1,
        name: 'Nelly Brown',
        datePosted: '2 months ago',
        post: 'Great course! Foundational content explained very clearly.'
    },

    {
        banner: img2,
        name: 'Chris Mark',
        datePosted: 'a months ago',
        post: "It is literally a guide to UX. With this course, you will have the mindset and tools you need to start a project as a UX researcher."
    },

    {
        banner: img3,
        name: 'Peter Brown',
        datePosted: '2 months ago',
        post: 'Great course! Foundational content explained very clearly.'
    },
]